import http from '@services/http';
export default {
  getCompaniesInModule(moduleId) {
    return http.get('Companies/GetCompaniesByModuleId', {
      moduleId: moduleId
    });
  },

  getModule(moduleId) {
    return http.get('Modules/GetModuleByModuleId', {
      moduleId: moduleId
    });
  },

  updateModule(module) {
    return http.put(`Modules/UpdateModule`, module);
  }

};